import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { useSelector } from 'react-redux';
import { theme } from 'fpay-ui';
import { useTranslation } from 'react-i18next';
import { RadioGroup, FormControlLabel, Radio, Typography } from '@material-ui/core';
import { useBreakpoints } from '@hooks/NewBreakpoint';

const fontTypes = {
  button: css`
    ${({ theme }) => theme.textTypes['Body-2-w400']};
    line-height: normal;
  `,
};

const Title = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 21px;
  color: #444b62;
  width: 100%;
  ${({ theme }) => theme.breakpoint('md')} {
    min-width: 350px;
  }
`;

const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 32px 16px 32px 16px;
  flex-direction: column;
`;
const List = styled.ul`
  margin-left: 16px;
  margin-top: 24px;
`;

const Text = styled.li`
  font-size: 14px;
  color: #444b62;
  font-weight: 400;
`;
const Button = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    ${fontTypes.button}
    text-align: center;
    align-items: center;
    width: 97px;
    height: 48px;
    border-radius: 6px;
    pointer-events: ${(props) => props.disabled && 'none'};
    background-color: ${(props) =>
      props.noThanks ? '#ffffff' : props.disabled ? '#E4E6EB' : `${theme.colors.gbrand500}`};
    color: ${(props) =>
      props.noThanks ? `${theme.colors.gbrand500}` : props.disabled ? '#A2A7BA' : '#ffffff'};
    cursor: pointer;
    transition: all 0.3s ease 0s;
    &:hover {
      box-shadow: ${(props) => (props.noThanks ? '' : '0 1px 6px rgb(32 33 36 / 28%)')};
      background-color: ${(props) => (props.noThanks ? '' : `${theme.colors.gbrand600}`)};
      color: ${(props) => (props.noThanks ? `${theme.colors.gbrand600}` : '#ffffff')};
    }
    &:active {
      border: ${(props) => (props.noThanks ? '' : `1px solid ${theme.colors.gbrand500}`)};
    }
  `
);

const ConstainerButtons = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 8px;
  ${theme.breakpoint('md')} {
    justify-content: flex-end;
    margin-top: 24px;
  }
`;

const CreateReportsProgram = ({
  handleClose,
  handleCreate,
  value,
  handleChange,
  filterProgram,
}) => {
  const {
    legal_agent: { email: mail },
    created_at: createdAt,
    seller,
  } = useSelector((state) => state.login.merchant);
  const { limit_search_report: limitSearchReport } = useSelector((state) => state.config);

  const { t } = useTranslation();

  const { breakpoint } = useBreakpoints();

  return (
    <>
      <Container>
        <Title>¿Cuándo quieres que se genere tu reporte?</Title>
        <List>
          <Text>
            {' '}
            {t('reportsScreen.createReport.textDescription', {
              limitDays:
                limitSearchReport && seller.length
                  ? limitSearchReport[seller]
                  : limitSearchReport['ON THEM'],
            })}
          </Text>
          <Text>
            {t('reportsScreen.sendMail')}
            <b>{mail}</b>
          </Text>
          <Text>
            {t('reportsScreen.findSection')}
            <b>{t('reportsScreen.reports')}</b>
          </Text>
        </List>

        <RadioGroup
          aria-labelledby="radio-buttons-group"
          name="Flujo de Reportes"
          value={value}
          onChange={handleChange}
          page={value}
        >
          <FormControlLabel
            name="DAILY"
            testId="DAILY"
            value="DAILY"
            label={
              <Typography style={{ fontSize: 14, color: '#444B62' }}>Todos los días</Typography>
            }
            control={<Radio />}
            labelPlacement="start"
            style={{
              width: breakpoint === 'xs' ? 264 : 360,
              justifyContent: 'space-between',
              marginLeft: 0,
              fontSize: 14,
            }}
          />
          <FormControlLabel
            name="WEEKLY"
            testId="WEEKLY"
            value="WEEKLY"
            label={
              <Typography style={{ fontSize: 14, color: '#444B62' }}>
                Los lunes de cada semana
              </Typography>
            }
            control={<Radio />}
            labelPlacement="start"
            style={{
              width: breakpoint === 'xs' ? 264 : 360,
              justifyContent: 'space-between',
              marginLeft: 0,
            }}
          />
          <FormControlLabel
            name="MONTHLY"
            testId="MONTHLY"
            value="MONTHLY"
            label={
              <Typography style={{ fontSize: 14, color: '#444B62' }}>1ro de cada mes</Typography>
            }
            control={<Radio />}
            labelPlacement="start"
            style={{
              width: breakpoint === 'xs' ? 264 : 360,
              justifyContent: 'space-between',
              marginLeft: 0,
            }}
          />
        </RadioGroup>

        <ConstainerButtons>
          <Button noThanks onClick={handleClose} id="cancel-create-report">
            {t('reportsScreen.cancel')}
          </Button>
          <Button
            onClick={() => handleCreate(value)}
            disabled={filterProgram}
            id="confirm-create-report"
          >
            {t('reportsScreen.create')}
          </Button>
        </ConstainerButtons>
      </Container>
    </>
  );
};

export default CreateReportsProgram;
